export interface CreditCard {
  flag?: string;
  number?: string;
  cvv?: string;
  month?: string;
  year?: string;
  ownerName?: string;
  ownerCPF?: string;
  isRecurrentCreditCard?: boolean;
  recurrentCreditCardId?: number;
}

export interface PixData {
  payload?: string;
  qrcode?: string;
  qrcode64?: string;
  tagHtml?: string;
  showPixQrCode?: boolean;
  isPixCodeExpired?: boolean;
}

export interface PaymentState {
  creditCard?: CreditCard;
  bankSlipFile?: string;
  pixData: PixData;
  flagOptions?: string[];
  yearOptions?: string[];
  monthOptions?: string[];
  paymentValue?: number;
  currentPaymentMethod?: string;
  currentPaymentStatus?: string;
  isRecurrentCreditCard?: boolean;
}

const paymentState: PaymentState = {
  creditCard: {},
  bankSlipFile: undefined,
  pixData: {
    payload: undefined,
    qrcode: undefined,
    qrcode64: undefined,
    tagHtml: undefined,
  },
  monthOptions: undefined,
  flagOptions: undefined,
  yearOptions: undefined,
  paymentValue: undefined,
  currentPaymentMethod: undefined,
  currentPaymentStatus: undefined,
  isRecurrentCreditCard: undefined,
};

export default paymentState;
